// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"257b36ec","453":"44f79463","732":"70f791e2","977":"48b932e7"}[chunkId] + ".chunk.js";
};